import { Link as NextLink } from "@/i18n/routing";
import clsx from "clsx";
import styles from "./link.module.css";

interface ILinkProps extends React.ComponentProps<"a"> {
  children: React.ReactNode;
  underline?: boolean;
  className?: string;
  target?: string;
}

const Link = ({ children, underline, ...props }: ILinkProps) => {
  return (
    <NextLink
      {...props}
      href={props.href ?? "#"}
      className={clsx(
        styles.link,
        underline && styles.link__underline,
        props.className,
      )}
    >
      {children}
    </NextLink>
  );
};

export default Link;
